"use strict";
/**
 * Utils module.
 * @module regex
 * @see https://gitlab.cdfsunrise.com/frontend/core/-/tree/main/packages/utils
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUrl = exports.isHan = exports.isPassportCardTaiwan = exports.isPassportCardHongkongMacau = exports.isPassportCard = exports.isOfficerCard = exports.isMobileTaiwan = exports.isMobileMacau = exports.isMobileHongKong = exports.isMobileChina = exports.isMobile = exports.isIdCard = exports.isTel = exports.isQQ = exports.isDate = exports.isEmail = exports.matchRegex = void 0;
var exp = __importStar(require("./exp"));
/**
 * checke string with regex
 *
 * ```js
 * matchRegex("d@d.d", "EMAIL" );
 * //=> true
 * ```
 *
 * @param v {String|Number|Date} target string
 * @param regexKey {String} regex
 */
function matchRegex(v, key) {
    v = String(v);
    var nv = v.trim();
    var rex = exp[key];
    if (nv && rex.test(nv)) {
        return true;
    }
    return false;
}
exports.matchRegex = matchRegex;
/**
 * isEmail
 *
 * ```js
 * isEmail("d@d.d");
 * //=> true
 * ```
 *
 * @param v {String} target string
 */
function isEmail(v) {
    return matchRegex(v, 'EMAIL');
}
exports.isEmail = isEmail;
/**
 * isDate
 *
 * ```js
 * isDate(new Date());
 * //=> true
 * ```
 *
 * @param v {String} target string
 */
function isDate(v) {
    return matchRegex(v, 'DATE');
}
exports.isDate = isDate;
/**
 * isQQ
 *
 * ```js
 * isQQ(54645464);
 * //=> true
 * ```
 *
 * @param v {String} target string
 */
function isQQ(v) {
    return matchRegex(v, 'QQ');
}
exports.isQQ = isQQ;
/**
 * isTel
 *
 * ```js
 * isTel("027-87665432");
 * //=> true
 * ```
 *
 * @param v {String} target string
 */
function isTel(v) {
    return matchRegex(v, 'TEL');
}
exports.isTel = isTel;
/**
 * isIdCard
 *
 * ```js
 * isIdCard(130324200106012652);
 * //=> true
 * ```
 *
 * @param v {String} target string
 */
function isIdCard(v) {
    return matchRegex(v, 'IDCARD');
}
exports.isIdCard = isIdCard;
/**
 * isMobile
 *
 * ```js
 * isMobile(13402938476)
 * //=> true
 *
 * isMobile('13402938476')
 * //=> true
 *
 * isMobile('8613402938476')
 * //=> true
 *
 * isMobile('+8613402938476')
 * //=> true
 * ```
 *
 * @param v {String|Number} target string
 */
function isMobile(v) {
    return matchRegex(v, 'MOBILE');
}
exports.isMobile = isMobile;
/**
 * isMobileChina
 *
 * ```js
 * isMobileChina('13402938476')
 * //=> true
 *
 * isMobileChina('8613402938476')
 * //=> true
 *
 * isMobileChina('+8613402938476')
 * //=> true
 *
 * isMobileChina('94856780')
 * //=> true
 *
 * isMobileChina('6643248')
 * //=> true
 *
 * isMobileChina('0922887075')
 * //=> true
 *
 * isMobileChina('+8860922887075')
 * //=> true
 * ```
 *
 * @param v {String|Number} target string
 */
function isMobileChina(v) {
    return isMobile(v) || isMobileHongKong(v) || isMobileMacau(v) || isMobileTaiwan(v);
}
exports.isMobileChina = isMobileChina;
/**
 * isMobileHongKong
 *
 * ```js
 * isMobileHongKong(94856780)
 * //=> true
 *
 * isMobileHongKong('94856780')
 * //=> true
 *
 * isMobileHongKong('85294856780')
 * //=> true
 *
 * isMobileHongKong('+85294856780')
 * //=> true
 *
 * isMobileHongKong(64856780)
 * //=> true
 *
 * isMobileHongKong('64856780')
 * //=> true
 *
 * isMobileHongKong('85264856780')
 * //=> true
 *
 * isMobileHongKong('+85264856780')
 * //=> true
 * ```
 *
 * @param v {String|Number} target string
 */
function isMobileHongKong(v) {
    return matchRegex(v, 'MOBILE_HONGKONG');
}
exports.isMobileHongKong = isMobileHongKong;
/**
 * isMobileMacau
 *
 * ```js
 * isMobileMacau(6643248)
 * //=> true
 *
 * isMobileMacau('6643248')
 * //=> true
 *
 * isMobileMacau('8536643248')
 * //=> true
 *
 * isMobileMacau('+8536643248')
 * //=> true
 *
 * isMobileMacau(6843248)
 * //=> true
 *
 * isMobileMacau('6843248')
 * //=> true
 *
 * isMobileMacau('8536843248')
 * //=> true
 *
 * isMobileMacau('+8536843248')
 * //=> true
 * ```
 *
 * @param v {String|Number} target string
 */
function isMobileMacau(v) {
    return matchRegex(v, 'MOBILE_MACAU');
}
exports.isMobileMacau = isMobileMacau;
/**
 * isMobileTaiwan
 *
 * ```js
 * isMobileTaiwan(13402938476);
 * //=> true
 * ```
 *
 * @param v {String|Number} target string
 */
function isMobileTaiwan(v) {
    return matchRegex(v, 'MOBILE_TAIWAN');
}
exports.isMobileTaiwan = isMobileTaiwan;
/**
 * isOfficerCard
 *
 * ```js
 * isOfficerCard(`士字第P011816X号`);
 * //=> true
 * ```
 *
 * @param v {String|Number} target string
 */
function isOfficerCard(v) {
    return matchRegex(v, 'IDCARD_OFFICER');
}
exports.isOfficerCard = isOfficerCard;
/**
 * isPassportCard
 *
 * ```js
 * isPassportCard(`G12345678`);
 * //=> true
 * ```
 *
 * @param v {String|Number} target string
 */
function isPassportCard(v) {
    return matchRegex(v, 'PASSPORTCARD');
}
exports.isPassportCard = isPassportCard;
/**
 * isPassportCardHongkongMacau
 *
 * ```js
 * isPassportCardHongkongMacau(`H1234567890`);
 * //=> true
 * ```
 *
 * @param v {String|Number} target string
 */
function isPassportCardHongkongMacau(v) {
    return matchRegex(v, 'PASSPORTCARD_HONGKONG_MACAU');
}
exports.isPassportCardHongkongMacau = isPassportCardHongkongMacau;
/**
 * isPassportCardTaiwan
 *
 * ```js
 * isPassportCardTaiwan(`1234567890B`);
 * //=> true
 * ```
 *
 * @param v {String|Number} target string
 */
function isPassportCardTaiwan(v) {
    return matchRegex(v, 'PASSPORTCARD_TAIWAN');
}
exports.isPassportCardTaiwan = isPassportCardTaiwan;
/**
 * isHan
 *
 * ```js
 * isHan(`汉字`);
 * //=> true
 * ```
 *
 * @param v {String|Number} target string
 */
function isHan(v) {
    return matchRegex(v, 'HAN');
}
exports.isHan = isHan;
/**
 * isUrl
 *
 * ```js
 * isUrl(`https://demo.com/a`);
 * //=> true
 * ```
 *
 * @param v {String|Number} target string
 */
function isUrl(v) {
    return matchRegex(v, 'URL');
}
exports.isUrl = isUrl;
//# sourceMappingURL=index.js.map